// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__Lmjxk","hidden":"Pagination_hidden__sZx4D","page":"Pagination_page__b8zgk","active":"Pagination_active__EYQSO"};